import { useDispatch, useSelector } from "react-redux";
import { getErrors } from "./selectors";
import { receiveErrors } from "./actions";

export default function useErrors() {
	const dispatch = useDispatch();
	const errors = useSelector(getErrors);

	const onReceiveErrors = (errors) => {
		dispatch(receiveErrors(errors));
	};

	return {
		errors,
		onReceiveErrors,
	};
}
